module.exports = __webpack_public_path__ + "img/eat-category-icon.a3103193.svg";